import { Stack, Typography } from '@mui/material'
import { TwinInstruction } from 'api/model'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import { COLORS } from 'app-constants'

const SuggestedQuestionItem = ({
  suggestedQuestion,
  onSuggestedQuestionClick,
}: {
  suggestedQuestion: TwinInstruction | null
  onSuggestedQuestionClick?: (suggestedQuestionId: string) => void
}) => {
  const onClick = () => {
    onSuggestedQuestionClick?.(suggestedQuestion?.id || '')
  }

  return (
    <Stack
      borderRadius="8px"
      direction="row"
      alignItems="center"
      p="8px 12px"
      mb="4px"
      onClick={onClick}
      sx={{
        border: `1px solid ${COLORS.GRAY_5}`,
        background: COLORS.PURE_WHITE,
        width: '100%',
        alignItems: 'center',
        cursor: onSuggestedQuestionClick ? 'pointer' : 'default',
      }}>
      {suggestedQuestion && (
        <DragIndicatorIcon
          sx={{
            color: COLORS.GRAY_3,
            height: '16px',
            width: '16px',
          }}
        />
      )}
      <Typography
        variant="pS"
        sx={{
          textAlign: 'left',
          color: suggestedQuestion ? COLORS.GRAY_0 : COLORS.GRAY_3,
          ml: 1,
        }}>
        {suggestedQuestion ? suggestedQuestion.query : 'Add a suggested question'}
      </Typography>
    </Stack>
  )
}

export default SuggestedQuestionItem
